import script from "./ConfigurationPriceCalculator.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigurationPriceCalculator.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__